/* ss-card-add — AJAX add for the product-card forms (.ss-rail__card).
   The cards are real /cart/add forms so app hooks can bind to them, but
   GoKwik's cart is configured NOT to (customATCHandling=true), so the native
   submit did a full page POST → /cart → /?openCart=true reload. Intercept:
   POST /cart/add.js, spinner on the pressed button, bump the header badge,
   open GoKwik's side cart when present. Shopify 4xx (sold out, over-stock
   cap, bad variant, 429) is shown inline — never a page reload. Only a
   network failure falls back to the native submit. */
(function () {
  if (window.__ssCardAdd) return; window.__ssCardAdd = true;
  var afterAdd = function () {
    if (window.publish && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ss-card-add' });
    else fetch('/cart.js').then(function (x) { return x.json(); }).then(function (c) { document.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = c.item_count; b.classList.toggle('ss-h__badge--empty', !c.item_count); }); }).catch(function () {});
    if (window.refreshSideCart) window.refreshSideCart();
    if (window.openGokwikSideCart) window.openGokwikSideCart();
  };
  var notice = function (form, text, soldOut) {
    var el = form.querySelector('.ss-rail__err') || form.appendChild(Object.assign(document.createElement('span'), { className: 'ss-rail__err', role: 'status' }));
    el.textContent = text; form.classList.add('is-error');
    setTimeout(function () { form.classList.remove('is-error'); }, 3000);
    if (soldOut && !form.querySelector('.ss-rail__soldout-ov')) {
      var ov = document.createElement('div'); ov.className = 'ss-rail__soldout-ov'; ov.innerHTML = '<span class="ss-rail__soldout">Sold out</span>';
      (form.querySelector('.ss-rail__media') || form).appendChild(ov);
    }
  };
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form.ss-rail__card');
    if (!form || form.dataset.adding) return;
    var vid = form.querySelector('[name="id"]'); if (!vid) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('.ss-rail__add') || form.querySelector('.ss-rail__qbtn');
    var done = function () { delete form.dataset.adding; form.classList.remove('is-adding'); if (btn) btn.disabled = false; };
    form.dataset.adding = '1'; form.classList.add('is-adding'); if (btn) btn.disabled = true;
    fetch(window.routes && routes.cart_add_url ? routes.cart_add_url + '.js' : '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid.value, quantity: 1 }] })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        var msg = j.description || j.message || '';
        var partial = r.status === 422 && /^Only \d+ item/i.test(msg); /* Shopify capped the qty but DID add */
        if (r.ok || partial) {
          form.classList.add('is-added'); setTimeout(function () { form.classList.remove('is-added'); }, 1800);
          if (partial) notice(form, msg, false);
          afterAdd();
        } else {
          notice(form, msg || (r.status === 429 ? 'Too many requests — try again in a moment.' : 'Could not add — please try again.'), /sold out/i.test(msg));
        }
        done();
      });
    }).catch(function () { done(); form.submit(); /* network failure only: native fallback keeps the sale */ });
  }, true);
})();
